<form novalidate [formGroup]="_form" (keydown.enter)="$event.preventDefault()" class="form_style">
  <div class="row">
    <div class="col-12">
      <div class="transaction-section-header">
        <div class="transaction-section-header-title">
          @if (!showTextBox) {
            <div (dblclick)="showTextbox()" class="">{{title}}</div>
          }
          <div>
            @if (showTextBox) {
              <input type="text"
                #titleTextBox
                [value]="title"
                id="titleTextBox"
                (blur)="closeTextbox($event.target)"
                (keyup.enter)="closeTextbox($event.target)" />
            }
          </div>
        </div>
        <div class="transaction-section-header-actions header-actions">
          @if (_selectedLocations.length > 0) {
            <button class="hidden-xs asap-btn" kendoButton (click)="_onAllVariance()">
              <!-- <span><img [src]="'/assets/menu/'+ _theme +'/eye-icon.svg'" /></span> -->
              Show All Variance
            </button>
          }
          <button class="hidden-xs asap-btn" kendoButton (click)="_onSave($event)">
            <span>
              <img [src]="'/assets/menu/'+ _theme +'/proccess-icon.svg'" />
            </span>Process
          </button>
          <button class="hidden-xs asap-btn" kendoButton (click)="_onClear()">
            <span><img [src]="'/assets/menu/'+ _theme +'/clear-icon.svg'" /></span>Clear
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="row no-row-margin">
    <!-- Search -->
    <div class="col-12 col-lg-6 small-pad-right">
      <div class="transactionWidget">
        <div class="row">
          <div class="col-12">
            <p class="titleStandardStyle">Set Starting/Ending date</p>
          </div>
          @if (_currentUser && _currentUser.isEnterprise) {
            <div class="col-12">
              <div class="form-group special_style_formgroup">
                <div class="row">
                  <div class="col-2">
                    <label class="control-label">Site</label>
                  </div>
                </div>
                <div class="transaction--stock-right-checkbox empty-small"></div>
              </div>
            </div>
          }
          <div class="col-12 margin-top-10">
            <div class="form-group special_style_formgroup">
              <div class="row">
                <div class="col-2">
                  <label class="control-label">Start Date/Time</label>
                </div>
                <div class="col-10 transaction-input-fields">
                  <kendo-datetimepicker #kendo_Start_Date_Time_Piker
                    formControlName="startDate"
                    class="newFormControlWidth"
                    (valueChange)="_startDateSubmited()"
                    (open)="_startDateOpened()"
                    placeholder="Start Date and Time"
                    [format]="_datePickerFormat"
                    [attr.disabled]="_dateEnabled ? null : 'disabled'">
                  </kendo-datetimepicker>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 margin-top-10">
            <div class="form-group special_style_formgroup">
              <div class="row">
                <div class="col-2">
                  <label class="control-label">End Date/Time</label>
                </div>
                <div class="col-10 transaction-input-fields">
                  <kendo-datetimepicker #kendo_End_Date_Time_Piker
                    formControlName="endDate"
                    class="newFormControlWidth"
                    (valueChange)="_endDateSubmited()"
                    (open)="_endDateOpened()"
                    placeholder="End Date and Time"
                    [format]="_datePickerFormat"
                    [attr.disabled]="_dateEnabled ? null : 'disabled'">
                  </kendo-datetimepicker>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-6 small-pad-left">
      <div class="transactionWidget" (click)="_listboxClicked()" [class.active]="_addClassActiveLocation">
        <div class="row">
          <div class="col-12">
            <p class="titleStandardStyle withPadding">Select Location</p>
          </div>
          <div class="col-12">
            @if (_locations) {
              <asap-fields-select-from-boxes [fields]="_locations"
                [selectedFields]="_selectedLocations"
                (selectedFieldsOutput)="_onLocationChange($event)"
                [displayFieldName]="'code'"
                [title]="'Location'"
                [fullWidth]="true"
                [showFilters]="true">
              </asap-fields-select-from-boxes>
            }
          </div>
        </div>
      </div>
    </div>
    <!-- Grid Data -->
    @if (_physicalInventoryGridData.length > 0) {
      <div class="col-12">
        <div class="asap-section-container with-grid" (click)="_gridclicked()" [class.active]="_addClassActiveGrid">
          <div class="row zeromarginRow">
            <div class="col-12">
              <p class="titleStandardStyle margin-top-10">
                <span>Selected Items</span>
                <span class="autoGenerateSection">
                  <span>
                    <input type="checkbox" kendoCheckBox (click)="_selectAdjustAll()" [checked]="_allSelected" />
                    <label class="control-label autoGenerateLabel">Adjust All</label>
                  </span>
                </span>
              </p>
            </div>
          </div>
          <div #gridWrapper>
            <kendo-grid [data]="_physicalInventoryGridData" [resizable]="true" class="asap-standalone-grid">
              <kendo-grid-column field="stockItem.number" title="Stock Item#">
              </kendo-grid-column>
              <kendo-grid-column field="stockItem.description" title="Stock Description">
              </kendo-grid-column>
              <kendo-grid-column field="inventoryNumber" title="Inventory ID#">
              </kendo-grid-column>
              <kendo-grid-column field="reason" title="Reason">
              </kendo-grid-column>
              <kendo-grid-column field="stockLocation.location.code" title="Previous Location">
              </kendo-grid-column>
              <kendo-grid-column field="location.code" title="Physical Inventory Location">
              </kendo-grid-column>
              <kendo-grid-column field="stockLocation.availability" title="Previous Quantity">
              </kendo-grid-column>
              <kendo-grid-column field="quantity" title="Line Item Count">
              </kendo-grid-column>
              <kendo-grid-column field="totalCount" title="Total Count">
              </kendo-grid-column>
              <kendo-grid-column field="qtyVariance" title="Qty Variance">
              </kendo-grid-column>
              <kendo-grid-column field="quantityToPost" title="Quantity To Post" [width]="230">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <kendo-numerictextbox class="k-textbox writebox smallNumeric" [autoCorrect]="true" [min]="0" [max]="dataItem?.stockItem?.itemType?.id == 2 ? 1 : null" [value]="dataItem.quantityToPost" (valueChange)="_QuantityToPost(dataItem,$event)">
                  </kendo-numerictextbox>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="adjust" title="Adjust">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <input type="checkbox" class="k-checkbox" kendoCheckBox [checked]="dataItem.adjust" (click)="_checkAdjust(dataItem)" />
                </ng-template>
              </kendo-grid-column>
            </kendo-grid>
          </div>
        </div>
      </div>
    }
  </div>
  <div class="row">
    <div class="col-12">
      @if (_invalidForm) {
        <asap-forms-validation-summary [form]="_form" [page]="'physical-inventory'">
        </asap-forms-validation-summary>
      }
    </div>
  </div>
</form>
